import moment from 'moment'
import { isString } from 'lodash'

import { deepFuse, isObject } from '..'
import { OrderDirections } from '../constants'
import Clonable from './clonable'
import { API_DATE } from '../momentjs'

const DEFAULT_PAGE_SIZE = 10
const DEFAULT_ORDER = { by: null, direction: OrderDirections.ASC }

export class TableParameters extends Clonable {
  /**
   * @param {Object} tableParameters
   * Parameters `orderBy` and `orderDirection` are deprecated. Use `order.by` and `order.direction` instead.
   * @param {string} tableParameters.orderBy - Deprecated
   * @param {string} tableParameters.orderDirection - Deprecated
   */
  constructor ({ order = DEFAULT_ORDER, page = 1, pageSize = DEFAULT_PAGE_SIZE, period, filters = {}, search = '', orderBy, orderDirection, metadata = null } = {}) {
    super()
    this.filters = filters
    this.order = { ...DEFAULT_ORDER, ...order }
    this.page = page
    this.pageSize = pageSize
    this.period = period
    this.search = search
    this.metadata = metadata ?? null

    if (isString(orderBy)) {
      console.warn('Parameter `orderBy` is deprecated. Please use `order.by` instead.')
      this.order.by = orderBy
    }

    if (isString(orderDirection)) {
      console.warn('Parameter `orderDirection` is deprecated. Please use `order.direction` instead.')
      this.order.direction = orderDirection
    }
  }

  toQueryParameters (additionalParameters = {}) {
    const query = {
      page: this.page,
      pageSize: this.pageSize,
      filters: this.filters,
      order: {
        by: this.order.by,
        direction: this.order.direction
      }
    }

    if (isObject(this.period)) {
      query.period = {
        startDate: isObject(this.period.startDate) ? moment(this.period.startDate).format(API_DATE) : null,
        endDate: isObject(this.period.endDate) ? moment(this.period.endDate).format(API_DATE) : null
      }
    }

    if (isString(this.search) && this.search.length > 0) {
      query.search = this.search
    }

    return deepFuse(query, additionalParameters)
  }

  /**
   * @deprecated 2025-01-20
   * @see {toQueryParameters} Use instead.
   * Difference : old method place most params directly in query. Now, params are grouped in prefered objects.
   */
  toQueryParametersOld () {
    return {
      endDate: isObject(this.period) ? moment(this.period.endDate).format(API_DATE) : undefined,
      filters: this.filters,
      search: this.filters.search ?? this.search,
      orderBy: this.order.by,
      orderDirection: this.order.direction,
      page: this.page,
      pageSize: this.pageSize,
      startDate: isObject(this.period) ? moment(this.period.startDate).format(API_DATE) : undefined
    }
  }
}
